import { ArrowUpCircleIcon, ServerStackIcon } from "@heroicons/react/24/solid";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Fragment, useState, useCallback } from "react";
import EntityTable from "./EntityTable";
import {
  getEntity,
  bulkDeleteEntity,
  searchEntity,
  exportEntities,
} from "../../../actions/Utilities/Entity";
import AddEntityForm from "./AddEntityForm";
import AddButton from "../../../components/AddButton";
import { store } from "react-notifications-component";
import SearchButton from "../../../components/SearchButton";
import DownloadButton from "../../../components/DownloadButton";
import { toast } from "../../../components/toastNotification";
import TextInput from "../../../components/TextInput";
import RefreshButton from "../../../components/RefreshButton";
import MassUploadButton from "../../../components/MassUploadButton";
import MassUpload from "./MassUpload";
import ConfirmBoxDelete from "../../../components/ConfirmBoxDelete";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../PermissionsConstants";
import { notificationFilterById } from "../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import { accountAtom } from "../../Login/atoms/AccountAtom";

const Entity = () => {
  const [EntityData, setEntityData] = useState([]);
  const [searchInputsData] = useState([]);
  const [filterEntityData, setFilterEntityData] = useState([]);
  const [searchEntities, setSearchEntities] = useState("");
  const queryClient = useQueryClient();
  const [isFilter, setIsFilter] = useState(false);
  const [addEntity, setaddEntity] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [massUploadModal, setMassUploadModal] = useState(false);
  const [rowIsExpanded, setRowExpanded] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const addPermission = PERMISSIONS.permission_utilities_entity_add;
  const downloadPermission = PERMISSIONS.permission_utilities_entity_download;
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);

  //Fetching Entity Details
  const { refetch, isFetching } = useQuery("Entity", getEntity, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
          store.addNotification(
            toast.fire("Server Error", "Cannot display data", "error")
          );
        } else {
          if (recordIdFromRecent === "") {
            let entityData = res;

            if (user.isMexico && !user.isFranchise && !user.isNonFranchise) {
              entityData = res.filter((x) => x.usedInMexico === true);
            } else if (
              !user.isMexico &&
              (user.isFranchise || user.isNonFranchise)
            ) {
              entityData = res.filter((x) => x.usedInMexico !== true);
            }

            setEntityData(
              entityData.map((responseData) => {
                return {
                  ...responseData,
                };
              })
            );
          } else {
            notificationFilterById(
              recordIdFromRecent.recordId,
              recordIdFromRecent.moduleName,
              recordIdFromRecent.subModuleName
            ).then((result) => {
              setEntityData(result);
            });
            history.replace();
          }
        }
      } else {
        toast.fire("No Data:", "No available data to display.", "info");
      }
    },
  });

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.entityId);

    bulkDeleteEntitities.mutate(ids);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Entities" : "Entity"
    }?`}</div>
  );
  const handleSearchInputs = (field, value) => {
    if (field === "Search") {
      searchInputsData.Search = value?.trim();
    }
    if (field === "Refresh") {
      searchInputsData.EntityName = "";
    }
  };
  const handleSelectedRowsChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    setIsBulkSelected((prev) => !prev);
    setRowsCount(state.selectedRows.length);
  }, []);
  const handleExportButton = () => {
    try {
      var myCurrentDate = new Date();
      var date =
        myCurrentDate.getFullYear() +
        "-" +
        (myCurrentDate.getMonth() + 1) +
        "-" +
        myCurrentDate.getDate() +
        " " +
        myCurrentDate.getHours() +
        ":" +
        myCurrentDate.getMinutes() +
        ":" +
        myCurrentDate.getSeconds();
      const ids = isFilter
        ? filterEntityData.map((row) => row.entityId)
        : EntityData.map((row) => row.entityId);
      exportEntities(ids, isFilter).then((content) => {
        var url = window.URL.createObjectURL(content.data);
        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", "Entities " + date + ".xlsx");
        tempLink.click();
        toast.fire("Success", "Entities were Exported Successfully", "success");
      });
    } catch (error) {
      toast.fire(
        "Failed to Export",
        "Server Error: Cannot Entities Codes due to: " + error,
        "error"
      );
    }
  };

  const handleClickSearch = () => {
    setIsFilter(true);
    searchMutation.mutate(searchInputsData);
  };
  const refreshTable = () => {
    setIsFilter(false);
    setSearchEntities("");
  };
  const searchMutation = useMutation(
    (searchInputsData) => searchEntity({ ...searchInputsData }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        queryClient.invalidateQueries("Entity");
        setFilterEntityData(
          res.map((responseData) => {
            return {
              ...responseData,
            };
          })
        );
      },
      onError: (error) => {},
    }
  );
  const bulkDeleteEntitities = useMutation((ids) => bulkDeleteEntity(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries("Entity");
      toast.fire("Success", "Entity were Deactivated Successfully", "success");
      refetch();
      setOpenModal(false);
      setIsBulkSelected(false);
      setSelectedRows([]);
      setClearSelectedRows(true);
    },
    onError: (error) => {
      toast.fire(
        "Bulk Deactivation of Fees Failed",
        "Server Error: Cannot Deactivate Carriers",
        "error"
      );
      setSelectedRows([]);
      setClearSelectedRows(true);
    },
  });

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  //Generate Components

  return (
    <Fragment>
      <MassUpload
        isOpen={massUploadModal}
        setMassUploadModal={setMassUploadModal}
      />
      <div className="animate-fade-in-down">
        <div className="mx-8 py-4">
          {addEntity ? (
            ""
          ) : (
            <>
              {/* {" "} */}

              <div className="flex gap-2 items-center">
                <div>
                  <ServerStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Utilities Module
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    ENTITY
                  </h1>
                </div>
              </div>
              <div className="h-0.5 w-full border-b-2 border-secondary mt-2 mb-4" />
            </>
          )}
          {addEntity ? (
            ""
          ) : (
            <div className="flex justify-between text-xs items-center w-full">
              <div className="flex flex-row w-1/2 items-center gap-2">
                <div className="w-1/4">
                  <TextInput
                    value={searchEntities}
                    placeholder="Entity Name"
                    className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                    onChange={(e) => {
                      setSearchEntities(e.target.value);
                      handleSearchInputs(
                        // "EditProducerCode",
                        "Search",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <SearchButton
                  buttonValue="Search"
                  className={
                    searchEntities.length === 0 ||
                    selectedRows.length > 0 ||
                    rowIsExpanded
                      ? "opacity-50"
                      : "opacity-100"
                  }
                  disabled={
                    searchEntities.length === 0 ||
                    selectedRows.length > 0 ||
                    rowIsExpanded
                      ? true
                      : false
                  }
                  onClick={() => handleClickSearch()}
                />
                <RefreshButton
                  className={
                    searchEntities.length === 0 ||
                    selectedRows.length > 0 ||
                    rowIsExpanded
                      ? "opacity-50"
                      : "opacity-100"
                  }
                  disabled={
                    searchEntities.length === 0 ||
                    selectedRows.length > 0 ||
                    rowIsExpanded
                      ? true
                      : false
                  }
                  onClick={() => {
                    refreshTable();
                    handleSearchInputs("Refresh", "");
                  }}
                />
              </div>
              <div className="flex flex-row gap-2 items-center">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    className={
                      selectedRows.length > 0 || rowIsExpanded
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    disabled={
                      selectedRows.length > 0 || rowIsExpanded ? true : false
                    }
                    buttonText="New Entity"
                    onClick={() => setaddEntity(true)}
                  />
                ) : (
                  ""
                )}
                {userPermissions.includes(addPermission) ? (
                  <MassUploadButton
                    onClickFunction={() => setMassUploadModal(true)}
                    className={
                      selectedRows.length > 0 || rowIsExpanded
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    disabled={
                      selectedRows.length > 0 || rowIsExpanded ? true : false
                    }
                  >
                    <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                    Mass Upload
                  </MassUploadButton>
                ) : (
                  ""
                )}
                {userPermissions.includes(downloadPermission) ? (
                  <DownloadButton
                    className={
                      selectedRows.length > 0 || rowIsExpanded
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    disabled={
                      selectedRows.length > 0 || rowIsExpanded ? true : false
                    }
                    buttonValue="Download File"
                    onClick={handleExportButton}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
          {addEntity && (
            <AddEntityForm
              EntityData={EntityData}
              Cancel={() => setaddEntity(false)}
              setaddEntity={setaddEntity}
              hideActionColumn={false}
              setSearchEntities={setSearchEntities}
              refetch={isFilter ? handleClickSearch : refreshTable}
            />
          )}
          <ConfirmBoxDelete
            ModalTitle="Deactivate Entity"
            qConfirmation={deleteMessage}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />

          {addEntity ? (
            ""
          ) : (
            <EntityTable
              EntityData={isFilter ? filterEntityData : EntityData}
              selectableRows={true}
              updateEntityList={isFilter ? handleClickSearch : refreshTable}
              selectedRows={selectedRows}
              handleBulkDelete={handleBulkDelete}
              setOpenModal={setOpenModal}
              setIsBulkSelected={setIsBulkSelected}
              handleSelectedRowsChange={handleSelectedRowsChange}
              setMassUploadModal={setMassUploadModal}
              rowIsExpanded={setRowExpanded}
              clearSelectedRows={clearSelectedRows}
              isLoading={isFetching || searchMutation.isLoading}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Entity;
